export default {
  header: 'Informationen für {0}',
  loadData: 'Beladung',
  load: 'Beladung {0}',
  orderNo: 'Auftrg-Nr.',
  partNo: 'Teile-Nr.',
  partDesc: 'TeilBez.',
  targetQuantity: 'Soll-Menge',
  actualQuantity: 'Ist-Menge',
  singleWeightText: 'Einzel-Gewicht',
  totalWeightText: 'Gesamt-Gewicht',
  productionOutput: 'Richtergebnis',
  quantityBreak: 'Menge Bruch',
  quantityCrack: 'Menge Riss',
  quantityNOK: 'Menge NIO',
  quantityOK: 'Menge IO',
  rightCycleTimeSeconds: 'Richtzykluszeit [s]',
  qmData: 'QS-Daten',
  restData: 'Rost-Daten',
  grateNo: 'RostNr',
  spsNo: 'SpsNr',
  startTime: 'Startzeit',
  endTime: 'Endezeit',
  previousEndTime: 'Vor. Endezeit',
  id: 'ID',
  treatment: 'Behandlung',
  grateType: 'Rost-Typ',
  zoneTimes: 'Zonen-Zeiten',
  zoneEntranceTime: 'Zonen-Einfahr-Zeit',
  zoneExitTime: 'Zonen-Ausfahr-Zeit',
  zone1EntryTime: 'Zone-1 Einfahr-Zeit',
  zone1ExitTime: 'Zone-1 Ausfahr-Zeit',
  zone2EntryTime: 'Zone-2 Einfahr-Zeit',
  zone2ExitTime: 'Zone-2 Ausfahr-Zeit',
  specialColor: 'Spezielle Farbe',
};
